// import { createContext, useContext, useState, useEffect } from 'react';

// const CartContext = createContext();

// export function CartProvider({ children }) {
//   const [cart, setCart] = useState(() => {
//     const saved = localStorage.getItem('brolax_cart');
//     return saved ? JSON.parse(saved) : [];
//   });

//   useEffect(() => {
//     localStorage.setItem('brolax_cart', JSON.stringify(cart));
//   }, [cart]);

//   const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
//   const cartTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

//   const addToCart = (product, quantity = 1) => {
//     setCart(prev => {
//       const existing = prev.find(item => item.id === product.id);
//       if (existing) {
//         return prev.map(item =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + quantity }
//             : item
//         );
//       }
//       return [...prev, { ...product, quantity }];
//     });
//   };

//   const removeFromCart = (productId) => {
//     setCart(prev => prev.filter(item => item.id !== productId));
//   };

//   const updateQuantity = (productId, quantity) => {
//     if (quantity < 1) {
//       removeFromCart(productId);
//       return;
//     }
//     setCart(prev =>
//       prev.map(item =>
//         item.id === productId ? { ...item, quantity } : item
//       )
//     );
//   };

//   const clearCart = () => {
//     setCart([]);
//   };

//   return (
//     <CartContext.Provider value={{
//       cart,
//       cartCount,
//       cartTotal,
//       addToCart,
//       removeFromCart,
//       updateQuantity,
//       clearCart
//     }}>
//       {children}
//     </CartContext.Provider>
//   );
// }

// export function useCart() {
//   const context = useContext(CartContext);
//   if (!context) {
//     throw new Error('useCart must be used within CartProvider');
//   }
//   return context;
// }

import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  // ========================
  // CART STATE
  // ========================
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem('brolax_cart');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  // ========================
  // CART DRAWER STATE
  // ========================
  const [isCartOpen, setIsCartOpen] = useState(false);

  // ========================
  // PERSIST CART
  // ========================
  useEffect(() => {
    localStorage.setItem('brolax_cart', JSON.stringify(cart));
  }, [cart]);

  // ========================
  // CART CALCULATIONS
  // ========================
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const cartTotal = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  // ========================
  // ACTIONS
  // ========================
  const addToCart = (product, quantity = 1) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);

      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }

      return [...prev, { ...product, quantity }];
    });
  };

  const removeFromCart = (productId) => {
    setCart((prev) => prev.filter((item) => item.id !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity < 1) {
      removeFromCart(productId);
      return;
    }

    setCart((prev) =>
      prev.map((item) =>
        item.id === productId
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
  };

  // ========================
  // PROVIDER
  // ========================
  return (
    <CartContext.Provider
      value={{
        // state
        cart,
        cartCount,
        cartTotal,
        isCartOpen,
        setIsCartOpen,

        // actions
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

// ========================
// HOOK
// ========================
export function useCart() {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }

  return context;
}